export interface Cacheable<T> {
  cache: {
    date: string;
  } | null;
  results: T[];
}

/**
 * Checks if an object implements the Cacheable interface
 * @param obj - The object to check
 * @returns true if the object implements Cacheable interface
 */
export const isCacheable = (obj: any): obj is Cacheable<any> =>
  !!obj &&
  typeof obj === 'object' &&
  Array.isArray(obj.results) &&
  obj.hasOwnProperty('cache') &&
  (obj.cache === null ||
    (typeof obj.cache === 'object' &&
      obj.cache !== null &&
      typeof obj.cache.date === 'string'));
